/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-suppliers.reducer';

export const PharmacySuppliersDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacySuppliersEntity = useAppSelector(state => state.pharmacySuppliers.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacySuppliersDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.detail.title">PharmacySuppliers</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacySuppliersEntity.id}</dd>
          <dt>
            <span id="supplierName">
              <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.supplierName">Supplier Name</Translate>
            </span>
          </dt>
          <dd>{pharmacySuppliersEntity.supplierName}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacySuppliersEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacySuppliersEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacySuppliersEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacySuppliersEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacySuppliersEntity.cursor}</dd>
          <dt>
            <span id="drugLicenceNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.drugLicenceNumber">Drug Licence Number</Translate>
            </span>
          </dt>
          <dd>{pharmacySuppliersEntity.drugLicenceNumber}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{pharmacySuppliersEntity.taxCode}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.contactCode">Contact Code</Translate>
          </dt>
          <dd>{pharmacySuppliersEntity.contactCode ? pharmacySuppliersEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacySuppliersEntity.pharmacy ? pharmacySuppliersEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySuppliers.supplier">Supplier</Translate>
          </dt>
          <dd>{pharmacySuppliersEntity.supplier ? pharmacySuppliersEntity.supplier.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-suppliers" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-suppliers/${pharmacySuppliersEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacySuppliersDetail;
